import { ActionContext } from "vuex";
import { ApartmentDto } from "@/api/models/coverage.model";
import { CustomerHandoverProcessDto } from "@/api/models/customer/customerHandover.model";
import { HandoverService } from "@/api/services/handover.service";
import { HANDOVER_MUTATION_TYPES } from "./constants";

interface HandoverActionContext extends ActionContext<any, any> {
	commit: (type: string, payload?: any) => void;
	state: any;
}

const saveHandoverApartment = ({ commit }: HandoverActionContext, apartment: ApartmentDto): void => {
	commit(HANDOVER_MUTATION_TYPES.SET_HANDOVER_APARTMENT, apartment);
};

const setHandoverType = ({ commit }: HandoverActionContext, handoverType: string): void => {
	commit(HANDOVER_MUTATION_TYPES.SET_HANDOVER_TYPE, handoverType);
};

const setHandoverProcess = ({ commit }: HandoverActionContext, process: CustomerHandoverProcessDto): void => {
	commit(HANDOVER_MUTATION_TYPES.SET_HANDOVER_PROCESS, process);
};

const clearHandoverData = ({ commit }: HandoverActionContext): void => {
	commit(HANDOVER_MUTATION_TYPES.CLEAR_HANDOVER);
};

const fetchHandoverProcess = async ({ commit, state }: HandoverActionContext, customerId: string): Promise<void> => {
	try {
		// Establecer estado de carga
		commit(HANDOVER_MUTATION_TYPES.SET_LOADING, true);
		commit(HANDOVER_MUTATION_TYPES.CLEAR_ERROR);

		const response = await HandoverService.getCustomerHandoverById(customerId);

		if (response.data) {
			commit(HANDOVER_MUTATION_TYPES.SET_HANDOVER_PROCESS, response.data);
			commit(HANDOVER_MUTATION_TYPES.SET_HANDOVER_TYPE, response.data.type);
		}
	} catch (error) {
		commit(HANDOVER_MUTATION_TYPES.SET_ERROR, "Error al obtener el proceso de handover");
		throw error;
	} finally {
		commit(HANDOVER_MUTATION_TYPES.SET_LOADING, false);
	}
};

/**
 * Valida la resegmentación del cliente
 */
const validateCustomerResegmentation = async ({ commit }: HandoverActionContext, customerId: string): Promise<void> => {
	try {
		commit(HANDOVER_MUTATION_TYPES.SET_LOADING, true);
		commit(HANDOVER_MUTATION_TYPES.CLEAR_ERROR);

		await HandoverService.validateCustomerResegmentation(customerId);
	} catch (error) {
		commit(HANDOVER_MUTATION_TYPES.SET_ERROR, "Error al validar la resegmentación");
		throw error;
	} finally {
		commit(HANDOVER_MUTATION_TYPES.SET_LOADING, false);
	}
};

const createCustomerResegmentation = async ({ commit }: HandoverActionContext, customerId: string): Promise<number> => {
	try {
		commit(HANDOVER_MUTATION_TYPES.SET_LOADING, true);
		commit(HANDOVER_MUTATION_TYPES.CLEAR_ERROR);

		const response = await HandoverService.createCustomerResegmentation(customerId);

		if (response.data) {
			const handoverId = response.data.id;
			commit(HANDOVER_MUTATION_TYPES.SET_HANDOVER_ID, handoverId);
			return handoverId;
		}

		throw new Error("No se pudo crear la resegmentación");
	} catch (error) {
		commit(HANDOVER_MUTATION_TYPES.SET_ERROR, "Error al crear la resegmentación");
		throw error;
	} finally {
		commit(HANDOVER_MUTATION_TYPES.SET_LOADING, false);
	}
};

const getAdditionalContacts = ({ commit, state }: HandoverActionContext) => {
	return new Promise((resolve, reject) => {
		const processId = state.process.id;
		HandoverService.getAdditionalContacts(processId)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveAdditionalContact = ({ commit, state }: HandoverActionContext, additionalContact: any) => {
	return new Promise((resolve, reject) => {
		additionalContact.customerHandoverProcessId = state.process.id;
		HandoverService.postAdditionalContact(additionalContact)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateAdditionalContact = ({ commit, state }: HandoverActionContext, additionalContact: any) => {
	return new Promise((resolve, reject) => {
		HandoverService.putAdditionalContact(additionalContact)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const deleteAdditionalContact = ({ commit, state }: HandoverActionContext, additionalContactId: string) => {
	return new Promise((resolve, reject) => {
		HandoverService.deleteAdditionalContact(additionalContactId)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

export default {
	saveHandoverApartment,
	setHandoverType,
	setHandoverProcess,
	clearHandoverData,
	fetchHandoverProcess,
	validateCustomerResegmentation,
	createCustomerResegmentation,
	getAdditionalContacts,
	saveAdditionalContact,
	updateAdditionalContact,
	deleteAdditionalContact
};
